/* © 2026 Lucky4voeter.nl - Premium UX micro-interactions (lightweight)
   Focus: Add-to-cart feedback, safe + fast (no dependencies beyond theme events).
*/
(() => {
  const PENDING_CLASS = 'l4v-atc-pending';
  const SUCCESS_CLASS = 'l4v-atc-success';

  // Track last clicked ATC button (card + product page)
  let lastBtn = null;

  const isATCButton = (el) => {
    if (!el) return false;
    return el.matches?.('button[type="submit"], input[type="submit"], .btn') &&
      (el.closest('form[action*="/cart/add"]') || el.closest('form[action="/cart/add"]') || el.closest('form[action*="add"]'));
  };

  const onPointerDown = (e) => {
    const btn = e.target.closest?.('button, input[type="submit"], a.btn');
    if (!btn || !isATCButton(btn)) return;

    lastBtn = btn;
    btn.classList.add(PENDING_CLASS);
    // prevent double-click spam while request runs
    btn.setAttribute('aria-busy', 'true');

    // Safety cleanup per click instead of a permanent interval.
    window.setTimeout(() => {
      if (document.body.contains(btn) && btn.classList.contains(PENDING_CLASS)) {
        btn.removeAttribute('aria-busy');
        btn.classList.remove(PENDING_CLASS);
      }
    }, 8000);
  };

  document.addEventListener('pointerdown', onPointerDown, { capture: true, passive: true });

  const clearPending = () => {
    document.querySelectorAll(`.${PENDING_CLASS}`).forEach((btn) => {
      btn.classList.remove(PENDING_CLASS);
      btn.removeAttribute('aria-busy');
    });
  };

  // Theme dispatches this after cart updates (cart.js)
  window.addEventListener('updated.ecomify.cart', () => {
    // Show success on the most recent button, if any
    if (lastBtn && document.body.contains(lastBtn)) {
      lastBtn.classList.remove(PENDING_CLASS);
      lastBtn.classList.add(SUCCESS_CLASS);
      lastBtn.removeAttribute('aria-busy');

      window.setTimeout(() => {
        if (document.body.contains(lastBtn)) lastBtn.classList.remove(SUCCESS_CLASS);
      }, 900);
    } else {
      clearPending();
    }
  });

  // No permanent interval: failed add-to-cart cleanup is scheduled per click above.
})();
